export const CHANGE_COURSEEXPER_DATA = 'courseexper/CHANGE_COURSEEXPER_DATA';
export const CHANGE_COURSEEXPER_LIST_DATA = 'courseexper/CHANGE_COURSEEXPER_LIST_DATA';
export const CHANGE_EXCELLENT_LIST = 'courseexper/CHANGE_EXCELLENT_LIST';
export const CHANGE_ATTACHMENT_LIST = 'courseexper/CHANGE_ATTACHMENT_LIST';
export const CHANGE_COLLECT = 'courseexper/CHANGE_COLLECT';








